import { Component, HostBinding, Input } from '@angular/core';

import { MenuModel } from '../../../../menu/models/menu.model';
import { RouteService } from '../../../../routing/services/route.service';

@Component({
    selector: 'li[menu-item]',
    templateUrl: './sidebar-item.component.html',
    styleUrls: ['./sidebar-item.component.scss']
})
export class SidebarItemComponent {

    public active = false;

    constructor(public route: RouteService) {
    }

    @HostBinding('class') classes: string;

    @Input() public item: MenuModel;

    public toggle() {
        this.active = !this.active;

        this.classes = this.active ? 'active open' : '';
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/layouts/components/partials/sidebar-item/sidebar-item.component.ts